import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as ArrowDownIcon } from "common/assets/icons/chevron-down.svg";
import { P } from "common/P/P";
import MultiSelectItem from "./MultiSelectItem";

const MultiSelect = ({
	label,
	options,
	onSelect,
	className,
	disabled = false,
}: any) => {
	const [isOpen, setIsOpen] = useState(false);
	const [selectedValues, setSelectedValues] = useState<any>([]);
	const dropdownRef = useRef<any>(null);

	useEffect(() => {
		const handleClickOutside = (event: any) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleItemSelect = (value: any) => {
		let newSelectedValues;
		if (selectedValues.includes(value)) {
			newSelectedValues = selectedValues.filter((item: any) => item !== value);
		} else {
			newSelectedValues = [...selectedValues, value];
		}
		setSelectedValues(newSelectedValues);
		onSelect(newSelectedValues);
	};

	const getTruncatedLabels = () => {
		const selectedLabels = options
			.filter((option: any) => selectedValues.includes(option.value))
			.map((option: any) => option.label)
			.join(", ");

		// Truncate if the length is greater than 30 characters
		return selectedLabels.length > 50
			? `${selectedLabels.substring(0, 40)}...`
			: selectedLabels;
	};

	return (
		<div className={`relative w-full ${className}`} ref={dropdownRef}>
			{label && (
				<P size="t1" type="regular" className="mb-1">
					{label}
				</P>
			)}
			<div
				onClick={() => !disabled && setIsOpen(!isOpen)}
				className="relative bg-white border rounded-md cursor-pointer border-strokeColor"
			>
				<div className="px-4 py-2 rounded-md">
					{getTruncatedLabels() || "Saylamak"}
				</div>
				<ArrowDownIcon className="absolute right-0 m-2 top-[3px]" />
			</div>
			{isOpen && (
				<div className="absolute z-10 w-full bg-white border border-strokeColor">
					{options.map((option: any) => (
						<MultiSelectItem
							key={option.value}
							value={option.value}
							isSelected={selectedValues.includes(option.value)}
							onSelect={handleItemSelect}
						>
							{option.label}
						</MultiSelectItem>
					))}
				</div>
			)}
		</div>
	);
};

export default MultiSelect;
